import { sriChaitanyaColors } from "./colors/sriChaitanya";
import type { Theme } from "../semantic/types";
import { baseTypography } from "./typography/base";
import { baseSpacing } from "./spacing/base";
import { baseRadii } from "./radii/base";
import { baseShadows } from "./shadows/base";
import { baseBorders } from "./borders/base";
import { baseLayout } from "./layout/base";
import { spacing } from "../primitives/spacing";

export const sriChaitanyaTheme: Theme = {
  name: "sriChaitanya",
  typography: baseTypography,
  spacing: baseSpacing,
  radii: baseRadii,
  shadows: baseShadows,
  borders: baseBorders,
  layout: baseLayout,
  colors: sriChaitanyaColors,

  text: {
    primary: sriChaitanyaColors.primary[10],
    secondary: sriChaitanyaColors.secondary[40],
    tertiary: sriChaitanyaColors.secondary[60],
    disabled: sriChaitanyaColors.secondary[80],
    inverse: sriChaitanyaColors.neutral[100],
    interactive: sriChaitanyaColors.primary[50],
    placeholder: sriChaitanyaColors.secondary[50],
  },

  surface: {
    page: sriChaitanyaColors.secondary[95],
    card: sriChaitanyaColors.neutral[100],
    overlay: sriChaitanyaColors.overlay,
    sidebar: sriChaitanyaColors.secondary[10],
    input: sriChaitanyaColors.neutral[100],
  },

  border: {
    default: sriChaitanyaColors.neutral[90],
    divider: sriChaitanyaColors.neutral[95],
    focus: sriChaitanyaColors.primary[50],
  },

  icon: {
    bottomPillActive: sriChaitanyaColors.primary[40],
    bottomPillInactive: sriChaitanyaColors.neutral[10],
  },

  input: {
    background: {
      default: sriChaitanyaColors.neutral[100],
      disabled: sriChaitanyaColors.neutral[95],
    },
    border: {
      default: sriChaitanyaColors.neutral[80],
      focus: sriChaitanyaColors.primary[50],
      error: sriChaitanyaColors.error[50],
    },
    padding: {
      sm: baseSpacing.sm,
      md: baseSpacing.md,
      lg: baseSpacing.lg,
    },
    radius: baseRadii.md,
  },

  select: {
    icon: {
      color: {
        default: sriChaitanyaColors.neutral[50],
        disabled: sriChaitanyaColors.neutral[80],
      },
    },
    item: {
      background: {
        default: sriChaitanyaColors.neutral[100],
        hover: sriChaitanyaColors.neutral[95],
        selected: sriChaitanyaColors.primary[10],
      },
      text: {
        default: sriChaitanyaColors.neutral[10],
        selected: sriChaitanyaColors.primary[60],
      },
    },
  },

  action: {
    primary: {
      default: sriChaitanyaColors.primary[50],
      hover: sriChaitanyaColors.primary[40],
      active: sriChaitanyaColors.primary[60],
      disabled: sriChaitanyaColors.primary[80],
      label: sriChaitanyaColors.neutral[100],
    },
    secondary: {
      default: sriChaitanyaColors.primary[95],
      hover: sriChaitanyaColors.primary[90],
      active: sriChaitanyaColors.primary[80],
      label: sriChaitanyaColors.primary[50],
    },
  },

  feedback: {
    info: sriChaitanyaColors.primary[50],
    success: sriChaitanyaColors.success[50],
    warning: sriChaitanyaColors.warning[50],
    error: sriChaitanyaColors.error[50],
  },

  control: {
    border: {
      default: sriChaitanyaColors.neutral[80],
      hover: sriChaitanyaColors.neutral[60],
      focus: sriChaitanyaColors.primary[50],
      active: sriChaitanyaColors.primary[60],
      disabled: sriChaitanyaColors.neutral[90],
      error: sriChaitanyaColors.error[50],
    },
    background: {
      default: sriChaitanyaColors.neutral[100],
      hover: sriChaitanyaColors.neutral[100],
      active: sriChaitanyaColors.neutral[95],
      disabled: sriChaitanyaColors.neutral[95],
    },
    text: {
      default: sriChaitanyaColors.neutral[10],
      placeholder: sriChaitanyaColors.neutral[50],
      disabled: sriChaitanyaColors.neutral[60],
      readonly: sriChaitanyaColors.neutral[40],
    },
    height: {
      sm: 32,
      md: 40,
      lg: 48,
    },
    padding: {
      x: {
        sm: baseSpacing.sm,
        md: baseSpacing.md,
        lg: baseSpacing.lg,
      },
    },
    radius: {
      sm: baseRadii.sm,
      md: baseRadii.md,
      lg: baseRadii.lg,
    },
  },
  textarea: {
    padding: {
      sm: baseSpacing.sm,
      md: spacing[5],
      lg: baseSpacing.lg,
    },
  },
};
